<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26.599" height="30" viewBox="0 0 26.599 30">
    <path
      d="M22.449 17.989a4.491 4.491 0 1 0 4.626 4.491 4.558 4.558 0 0 0-4.626-4.491zm0 7.389a2.9 2.9 0 1 1 2.989-2.9 2.945 2.945 0 0 1-2.989 2.901zM34.74 12.457h-3.529V5.964A3.523 3.523 0 0 0 27.639 2.5H17.26a3.523 3.523 0 0 0-3.571 3.464v6.493h-3.53a1 1 0 0 0-1.009.979v18.085a1 1 0 0 0 1.009.979H34.74a1 1 0 0 0 1.009-.979V13.436a1 1 0 0 0-1.009-.979zM15.73 5.964a1.51 1.51 0 0 1 1.53-1.484h10.379a1.51 1.51 0 0 1 1.53 1.484v6.493H15.73zm6.72 21.856a11.059 11.059 0 0 1-9.529-5.343 11.171 11.171 0 0 1 19.059 0 11.063 11.063 0 0 1-9.531 5.343z"
      transform="translate(-9.15 -2.5)"
    />
  </svg>
</template>
